import React from 'react';
import { CtaButton } from './CtaButton';
import { media } from '../data/product';
const milestones = [{
  year: 'The problem',
  body: 'A shop owner in Ohio was tired of watching his techs hold a flashlight in their teeth. Every job took longer than it should, and the good work happened in bad light.'
}, {
  year: 'The idea',
  body: 'Put the light where the eyes already are. Not on a strap. Not in a hand. Built into the glasses tradesmen already wear every day.'
}, {
  year: 'The build',
  body: 'Two light sources, three interchangeable lenses, USB-C charging and a frame light enough to forget you have it on. Tested by mechanics, roofers, electricians and drivers before anyone could buy one.'
}, {
  year: 'Today',
  body: 'Over 50,000 X1 are on American jobsites, and every one of them is backed by lifetime free replacement. Break it and we replace it. That is the whole promise.'
}];
export function StorySection() {
  return <section id="story" className="border-b border-white/10 bg-ink-900" data-id="element-857" data-mp="1o7oe8x58mi79">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-858" data-mp="1o5lf9nm3xeqe">
        <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-859" data-mp="1t698mfxt67ns">Our story</p>
        <div className="mt-4 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14" data-id="element-860" data-mp="1f6i0gvtz3lhp">
          <div data-id="element-861" data-mp="1k4jhzcbr3cr2">
            <h2 className="grit-headline text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-862" data-mp="1k87964tq3n2m">
              We build gear for
              <br data-id="element-863" data-mp="1a86ks4gzygrk" />
              <span className="text-grit-500" data-id="element-864" data-mp="1a8orxw576fe9">the people who build.</span>
            </h2>
            <p className="mt-5 max-w-xl text-lg text-steel-300" data-id="element-865" data-mp="whjr4qq3fh2c">
              GritVue started in a truck bay, not a boardroom. Same grit. Different jobs. A brighter tomorrow.
            </p>

            <ol className="mt-8 max-w-xl" data-id="element-866" data-mp="mjdmi1cwjwts">
              {milestones.map(milestone => <li key={milestone.year} className="border-t border-white/10 py-5" data-id="element-867" data-mp="rhoxwgiuife4">
                  <p className="font-display text-xl font-bold uppercase tracking-wide text-grit-500" data-id="element-868" data-mp="2t74l105vnymp">
                    {milestone.year}
                  </p>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-steel-300" data-id="element-869" data-mp="2odrycvkre1wl">{milestone.body}</p>
                </li>)}
            </ol>

            <div className="mt-8" data-id="element-870" data-mp="2fg989cs9cxdu">
              <CtaButton className="w-full sm:w-auto" data-id="element-871" data-mp="2fh10qeqk6ezw">Get your X1 from $39.95</CtaButton>
              <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-grit-500" data-id="element-872" data-mp="3c4xe7aqp8u6w">
                3 lenses included · Lifetime free replacement
              </p>
            </div>
          </div>

          <figure data-id="element-873" data-mp="332xweg7v1m2w">
            <img src={media.tradesSheet} alt="American tradesmen across mechanics, construction, HVAC, plumbing, electrical and trucking wearing the GritVue X1" className="block h-auto w-full border border-white/10" data-id="element-874" data-mp="336lln369vmbt" />
            <figcaption className="mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-steel-500" data-id="element-875" data-mp="1mp7mutxz25lv">
              Built for what matters
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}